import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useRemoveFromFarm = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["farm-unbind"],
    mutationFn: async (query) => {
      return await axios.post("/farm/unbind", query);
    },
  });
};
